import {Fragment, useEffect, useMemo, useState} from "react";
import {USED_DISCOUNT_LIST} from "../../../helperData/ApiAddress";
import {get} from "../../../controlers/global/ConfigRequest";
import {Spinner} from "react-bootstrap";
import moment from 'moment-jalaali';
import PaginationComponent from './../../../component/global/PaginationComponent';
import DBDateFilter from "../../../component/global/DBDateFilter";
import DBSelectFilter from "../../../component/global/DBSelectFilter";
import DBSearchFilter from "../../../component/global/DBSearchFilter";
import {ReactComponent as CoinIcon} from "../../../asset/icons/coin.svg";
import {ReactComponent as OtherDots} from "../../../asset/icons/otherDotsIcon.svg";
import {ReactComponent as TableFilter} from "../../../asset/icons/tableFiltericon.svg";
import {ReactComponent as SearchIcon} from "../../../asset/icons/searchIcon.svg";
import {useTranslation} from "react-i18next";
// import DiscountCardDetailModal_old from "./DiscountCardDetailModal_old";
const TableRow = ({id, row, title, company, code, startDate, endDate, coin, discount, active, onClick}) => {
  const {t} = useTranslation()

  return (
    <div className="discount-table-row">
      <div>
        <div>{row}</div>
      </div>
      <div className="auto-hide" title={title}>{title}</div>
      <div className="auto-hide" title={company}>{company}</div>
      <div>{code}</div>
      <div>{startDate}</div>
      <div>{endDate}</div>
      <div>
        <div className="flex"><CoinIcon/> {coin}</div>
      </div>
      <div>{discount}</div>
      <div>
        {active ?
          t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter2.true') :
          t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter2.Used')
        }
      </div>
      <div>
        <button onClick={() => onClick(id, true)}><OtherDots/></button>
      </div>
    </div>
  )
}

const initialDateState = {
  fa: "",
  en: "",
  set: false
}

export default function UsedCards({setId}) {
  const {t} = useTranslation()
  // const [startDate, setStartDate] = useState({fa: '1390-01-01', en: '2000-01-01', set: false});
  const [startDate, setStartDate] = useState(initialDateState);
  const [endDate, setEndDate] = useState(initialDateState);
  // const [endDate, setEndDate] = useState({fa: '1410-01-01', en: '2030-01-01', set: false});

  // const [startDatePicker, setStartDatePicker] = useState(false);
  // const [endDatePicker, setEndDatePicker] = useState(false);
  const [filterType, setFilterType] = useState("company");


  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [discountCards, setDiscountCards] = useState();
  const [cardLoader, setCardLoader] = useState(false);

  const selectFilter = useMemo(() => {
    return [
      {
        value: 'code',
        title: t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter1.Code')
      },
      {
        value: 'company',
        title: t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter1.Company')
      },
      {
        value: 'active',
        title: t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter1.Active')
      }
    ]
  }, [t])

  const selectFilter2 = useMemo(() => {
    return [
      {
        value: '',
        title: t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter2.Open')
      },
      {
        value: 'true',
        title: t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter2.true')
      },
      {
        value: 'false',
        title: t('Src.Pages.UserPages.UserDiscount.UsedCards.SelectFilter2.Used')
      }
    ]
  }, [t])

  const getUsedDiscountList = (filter = '') => {
    setCardLoader(true);
    get(USED_DISCOUNT_LIST, {
      [filterType]: filter || undefined,
      date_start: startDate.en || undefined,
      end_date: endDate.en || undefined,
      page: currentPage
    }).then(r => {
      setPageCount(r.lastPage);
      setDiscountCards(r.results);

    }).finally(() => {
      setCardLoader(false);
    })
  }
  useEffect(() => {
    getUsedDiscountList();
  }, []);

  useEffect(() => {
    setFilter("");
  }, [filterType]);

  return (
    <div className="used-cards-main user-exchange">
      <div className="toolbar">
        <div className="toolbar-type">
          {filterType === "active" ?
            <DBSelectFilter
              value={filter}
              onChange={e => setFilter(e.target.value)}
              icon={<SearchIcon/>}
              data={selectFilter2}
              className='used-cards-selectFilter-2'
              onClickIcon={() => {
                getUsedDiscountList(filter)
              }}
            />
            :
            <DBSearchFilter
              placeholder={t('Src.Pages.UserPages.UserDiscount.UsedCards.SearchLabel')}
              value={filter}
              onClick={(value) => {
                setFilter(value)
                getUsedDiscountList(value)
              }}
              className='used-cards-searchFilter'
            />
          }
          {/*<div className="toolbar-ic pad-st-ic">*/}
          {/*  <SearchIcon/>*/}
          {/*</div>*/}
          {/*<div className="toolbar-search">*/}
          {/*  {*/}
          {/*    filterType === "active" &&*/}
          {/*    <select value={filter} onChange={e => setFilter(e.target.value)}>*/}
          {/*      <option value="">همه</option>*/}
          {/*      <option value="true">باز</option>*/}
          {/*      <option value="false">استفاده شده</option>*/}
          {/*    </select>*/}
          {/*  }*/}
          {/*  {*/}
          {/*    filterType !== "active" &&*/}
          {/*    <input type="text" placeholder="جستجو" value={filter} onChange={e => setFilter(e.target.value)}/>*/}
          {/*  }*/}
          {/*</div>*/}

          <DBSelectFilter
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            icon={<TableFilter/>}
            data={selectFilter}
            className='used-cards-selectFilter'
          />
          {/*<select*/}
          {/*  value={filterType}*/}
          {/*  onChange={(e) => setFilterType(e.target.value)}*/}
          {/*>*/}
          {/*  <option value="code">بر اساس کد یکتا</option>*/}
          {/*  <option value="company">بر اساس سازمان</option>*/}
          {/*  <option value="active">بر اساس وضعیت</option>*/}
          {/*</select>*/}
        </div>
        <DBDateFilter
          className='used-cards-dateFilter'
          onStartDate={setStartDate}
          onEndDate={setEndDate}
          onRemoveStartDate={() => {
            setStartDate(initialDateState)
          }}
          onRemoveEndDate={() => {
            setEndDate(initialDateState)
          }}
        />
        {/*<div className="date-picker-1">*/}
        {/*  <div>*/}
        {/*    <input type="text" placeholder="از تاریخ" readOnly defaultValue={startDate.set ? startDate.fa : ""}*/}
        {/*           onClick={e => setStartDatePicker(true)}/>*/}
        {/*    {startDate.set && <button onClick={() => setStartDate({...startDate, set: false})}>حذف</button>}*/}
        {/*  </div>*/}
        {/*  <div>*/}
        {/*    <input type="text" placeholder="تا تاریخ" readOnly defaultValue={endDate.set ? endDate.fa : ""}*/}
        {/*           onClick={e => setEndDatePicker(true)}/>*/}
        {/*    {endDate.set && <button onClick={() => setEndDate({...endDate, set: false})}>حذف</button>}*/}
        {/*  </div>*/}
        {/*  <DatePickerModal show={startDatePicker} close={setStartDatePicker} defaultValue={startDate.fa}*/}
        {/*                   onChange={setStartDate}/>*/}
        {/*  <DatePickerModal show={endDatePicker} close={setEndDatePicker} defaultValue={endDate.fa}*/}
        {/*                   onChange={setEndDate}/>*/}
        {/*</div>*/}
        {/*<button onClick={getUsedDiscountList}>اعمال</button>*/}
      </div>
      <div className="discount-history-con">
        <div>
          {
            cardLoader &&
            <Spinner animation="border"/>
          }
          {
            !discountCards?.length && !cardLoader &&
            <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.NotFound')}</div>
          }
          {
            discountCards?.length && !cardLoader ?
              discountCards?.map((card, index) => {

                return (
                  <Fragment key={index}>
                    {
                      index === 0 &&
                      <div className="discount-table-title">
                        <div>
                          <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.Row')}</div>
                        </div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.CardTitle')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.Organization')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.UniqueCode')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.StartDate')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.EndDate')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.Score')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.Discount')}</div>
                        <div>{t('Src.Pages.UserPages.UserDiscount.UsedCards.Table.Status')}</div>
                        <div>&nbsp;</div>
                      </div>
                    }
                    <TableRow
                      id={card.discount_card.id}
                      key={"table" + index}
                      row={index + 1}
                      title={card.discount_card.name}
                      company={card.discount_card.company.name}
                      code={card.code}
                      startDate={moment(card.discount_card.date_start).format("jYYYY/jMM/jDD")}
                      endDate={moment(card.discount_card.date_end).format("jYYYY/jMM/jDD")}
                      coin={card.coin}
                      discount={card.discount_card.discount_amount}
                      active={card.active}
                      onClick={setId}
                    />
                  </Fragment>
                )
              }) : null
          }
        </div>

      </div>
      {
        !cardLoader && discountCards?.length &&
        <PaginationComponent
          pageCount={pageCount}
          key={currentPage}
          fetchData={e => console.log(e)}
          currentPage={currentPage - 1}
          setCurrentPage={e => setCurrentPage(e + 1)}
          feedbacks={4}
        />
      }
    </div>
  )
}
